export const GET_MOVIES_BY_DATE_REQUEST = 'GET_MOVIES_BY_DATE_REQUEST';
export const GET_MOVIES_BY_DATE_SUCCESS = 'GET_MOVIES_BY_DATE_SUCCESS';
export const GET_MOVIES_BY_DATE_FAILURE = 'GET_MOVIES_BY_DATE_FAILURE';
export const GET_MOVIES_LIST_REQUEST = 'GET_MOVIES_LIST_REQUEST';
export const GET_MOVIES_LIST_SUCCESS = 'GET_MOVIES_LIST_SUCCESS';
export const GET_MOVIES_LIST_FAILURE = 'GET_MOVIES_LIST_FAILURE';
export const GET_PAGING_LIST_MOVIES_REQUEST = 'GET_PAGING_LIST_MOVIES_REQUEST';
export const GET_PAGING_LIST_MOVIES_SUCCESS = 'GET_PAGING_LIST_MOVIES_SUCCESS';
export const ADD_LiST_DAY_HOMTOOLS_SUCCESS = 'ADD_LiST_DAY_HOMTOOLS_SUCCESS';
export const ADD_LiST_DAY_HOMTOOLS_FAILURE = 'ADD_LiST_DAY_HOMTOOLS_FAILURE';
export const ADD_FILM_SUCCESS = 'ADD_FILM_SUCCESS';
export const EDIT_FILM_SUCCESS = 'EDIT_FILM_SUCCESS';
export const DELETE_FILM_SUCCESS = 'DELETE_FILM_SUCCESS';

